import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 185,
        marginLeft: "124px",
        justifyContent: 'flex-start',
        width: '50%',
        position: "absolute",
    },
    billTo: {
        marginTop: 10,
        fontFamily: 'Times-Bold',
        color: '#0B5F68',
    },
    blackText: {
        color: 'black',
    },
});

const BillTo = ({ invoice }) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>
            Roll No: <Text style={styles.blackText}>{invoice?.rollNumber}</Text>
        </Text>
        <Text style={styles.billTo}>
            Name: <Text style={styles.blackText}>{invoice?.name}</Text>
        </Text>
        <Text style={styles.billTo}>
            Father Name: <Text style={styles.blackText}>{invoice?.fname}</Text>
        </Text>
        <Text style={styles.billTo}>
            Course: <Text style={styles.blackText}>{invoice?.course}</Text>
        </Text>
        <Text style={styles.billTo}>
            Batch: <Text style={styles.blackText}>{invoice?.batch}</Text>
        </Text>
    </View>
);

export default BillTo;
